import presetsService from '../services/PresetsService';
import each from 'lodash/each';

export const PRESETS_FETCH_REQUEST = 'PRESETS_FETCH_REQUEST';
export const PRESETS_FETCH_SUCCESS = 'PRESETS_FETCH_SUCCESS';
export const PRESETS_FETCH_FAILURE = 'PRESETS_FETCH_FAILURE';

export const fetchPresets = (force = false) => async (dispatch, getState) => {
    const presetsState = getState().presets;
    if (!force && (presetsState.fetched || presetsState.loading)) {
        return null;
    }
    dispatch({type: PRESETS_FETCH_REQUEST});
    try {
        const presets = await presetsService.getPresets();
        return dispatch({type: PRESETS_FETCH_SUCCESS, presets});
    } catch (error) {
        return dispatch({type: PRESETS_FETCH_FAILURE, error});
    }
};

export const PRESET_SAVE_REQUEST = 'PRESET_SAVE_REQUEST';
export const PRESET_SAVE_SUCCESS = 'PRESET_SAVE_SUCCESS';
export const PRESET_SAVE_FAILURE = 'PRESET_SAVE_FAILURE';

export const onSavePreset = (data, fetchAll = false) => async (dispatch, getState) => {
    dispatch({type: PRESET_SAVE_REQUEST});
    const {id} = data;
    try {
        const preset = await presetsService.persistPreset(data);
        if (fetchAll) {
            return fetchPresets(true)(dispatch, getState);
        }
        const successNotification = 'Preset saved successfully';
        return dispatch({type: PRESET_SAVE_SUCCESS, preset, id: preset.id, successNotification});
    } catch (error) {
        return dispatch({type: PRESET_SAVE_FAILURE, id, error, errorNotification: 'An error occurred when saving the preset'});
    }
};

export const PRESET_DELETE_REQUEST = 'PRESET_DELETE_REQUEST';
export const PRESET_DELETE_SUCCESS = 'PRESET_DELETE_SUCCESS';
export const PRESET_DELETE_FAILURE = 'PRESET_DELETE_FAILURE';

export const onDeletePreset = (id) => async (dispatch) => {
    dispatch({type: PRESET_DELETE_REQUEST});
    try {
        await presetsService.deletePreset(id);
        return dispatch({type: PRESET_DELETE_SUCCESS, id});
    } catch (error) {
        return dispatch({type: PRESET_DELETE_FAILURE, id, error});
    }
};

export const PRESET_FILTER_CHANGE = 'PRESET_FILTER_CHANGE';

export const onPresetsFilterChange = (value) => {
    return {type: PRESET_FILTER_CHANGE, value};
};

export const PRESET_SELECT = 'PRESET_SELECT';

export const onSelectPreset = (preset) => {
    return {type: PRESET_SELECT, preset};
};

export const IMAGE_VIEWER_TOGGLE_ORIGINAL = 'IMAGE_VIEWER_TOGGLE_ORIGINAL';

export const onImageViewerToggleOriginal = () => {
    return {type: IMAGE_VIEWER_TOGGLE_ORIGINAL};
};

export const onImageViewerToggleOriginalDemo = () => {
    return {type: IMAGE_VIEWER_TOGGLE_ORIGINAL, demo: true};
};

export const IMAGE_VIEWER_SET_PREFERRED_REQUEST = 'IMAGE_VIEWER_SET_PREFERRED_REQUEST';
export const IMAGE_VIEWER_SET_PREFERRED_SUCCESS = 'IMAGE_VIEWER_SET_PREFERRED_SUCCESS';
export const IMAGE_VIEWER_SET_PREFERRED_FAILURE = 'IMAGE_VIEWER_SET_PREFERRED_FAILURE';

const setPreferredPreset = (id, userId, amplitude, spread) => async (dispatch) => {
    dispatch({type: IMAGE_VIEWER_SET_PREFERRED_REQUEST});
    try {
        await presetsService.setPreferredPreset(id, amplitude, spread);
        return dispatch({type: IMAGE_VIEWER_SET_PREFERRED_SUCCESS, id, userId, amplitude, spread});
    } catch (error) {
        return dispatch({type: IMAGE_VIEWER_SET_PREFERRED_FAILURE, error});
    }
};

export const onImageViewerSetPreferred = () => (dispatch, getState) => {
    const openImage = getState().openImage;
    const {id, userId, amplitude, spread} = openImage;
    return setPreferredPreset(id, userId, amplitude, spread)(dispatch);
};

export const onImageViewerSelectionSetPreferred = () => (dispatch, getState) => {
    const state = getState();
    const openImage = state.openImage;
    const {images} = state.selectedImages;
    const {userId, amplitude, spread} = openImage;
    each(images, (id) => {
        setPreferredPreset(id, userId, amplitude, spread)(dispatch);
    });
};

export const onEditorSetPreferred = () => (dispatch, getState) => {
    const state = getState();
    const openImage = state.openImage;
    const {id, userId} = openImage;
    const {amplitude, spread} = state.controlPanel;
    return setPreferredPreset(id, userId, amplitude, spread)(dispatch);
};

export const USER_SET_PREFERRED_REQUEST = 'USER_SET_PREFERRED_REQUEST';
export const USER_SET_PREFERRED_SUCCESS = 'USER_SET_PREFERRED_SUCCESS';
export const USER_SET_PREFERRED_FAILURE = 'USER_SET_PREFERRED_FAILURE';

export const onSetUserPreferredPreset = (amplitude, spread) => async (dispatch, getState) => {
    const {id} = getState().auth.currentUser;
    dispatch({type: USER_SET_PREFERRED_REQUEST});
    try {
        await presetsService.setUserPreferredPreset(amplitude, spread);
        return dispatch({type: USER_SET_PREFERRED_SUCCESS, id, amplitude, spread});
    } catch (error) {
        return dispatch({type: USER_SET_PREFERRED_FAILURE, error});
    }
};

export const onAssignPresetNumber = (data) => {
    // todo: figure out a better way with chaining
    return onSavePreset(data, true);
};



// WEBPACK FOOTER //
// ./src/actions/PresetActions.js